import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import '../styles/Auth.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail]       = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Verify the email belongs to an active org member before sending reset link
      const { data: isMember, error: checkError } = await supabase.rpc(
        'check_email_is_org_member', { p_email: email }
      );
      if (checkError) throw checkError;
      if (!isMember) {
        setError('No account found for this email address. Please contact your admin.');
        setLoading(false);
        return;
      }

      const redirectTo = window.location.hostname === 'localhost'
        ? 'http://localhost:3000/reset-password'
        : `${window.location.origin}/reset-password`;

      const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
      if (error) throw error;
      setSubmitted(true);
    } catch (e: any) {
      setError(e.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-card-page">
      <div className="auth-card-panel">
        <h2>Reset your password</h2>

        {submitted ? (
          <>
            <div className="auth-card-alert-success">
              Check your inbox — we've sent a password reset link to <strong>{email}</strong>.
            </div>
            <p className="auth-card-hint">Didn't get it? Check your spam folder or try again.</p>
            <button className="auth-card-linkbtn" onClick={() => setSubmitted(false)}>
              Try a different email
            </button>
          </>
        ) : (
          <>
            <p className="auth-card-subtitle">
              Enter your account email and we'll send you a reset link.
            </p>
            {error && <div className="auth-card-alert-error">{error}</div>}
            <form onSubmit={handleSubmit} className="auth-card-form">
              <input
                className="auth-card-input"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
                disabled={loading}
              />
              <button type="submit" className="auth-card-btn" disabled={loading || !email}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
          </>
        )}

        <Link to="/login" className="auth-card-back">← Back to Login</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
